import { dateToFormat } from 'helpers/formatters/date';
import { AbsoluteReturnTimeWindow } from 'types/AbsoluteReturn';
import { Column } from 'types/Table';
import { formatToDate } from 'helpers/date';

export type RowType = {
  fromDate: string;
  returnComponent: string;
  basisPointAdjustment: string;
};

export const getRowFormatted = (row: any) => {
  return {
    tabName: row.fromDate,
    data: {
      fromDate: row.fromDate,
      returnComponent: row.returnComponent,
      basisPointAdjustment: row.basisPointAdjustment,
    },
  };
};

export const useTable = (
  data: Array<AbsoluteReturnTimeWindow> = [],
  onDeleteRow?: (fromDate: string) => void
) => {
  const columns: Array<Column> = [
    {
      Header: 'From Date',
      accessor: 'fromDate',
    },
    {
      Header: 'To Date',
      accessor: 'toDate',
    },
    {
      Header: 'Return Component',
      accessor: 'returnComponent',
    },
    {
      Header: 'Basis Point Adjustment',
      accessor: 'basisPointAdjustment',
      className: 'text-right',
      Cell: (row: any) => <div className='text-right'>{row.value}</div>,
    },
  ];

  const actionDeleteRow = (
    onCloseModal: any,
    row: AbsoluteReturnTimeWindow[]
  ) => {
    onDeleteRow?.(row[0].fromDate);
    onCloseModal();
  };

  return {
    data:
      data?.map((item: any) => ({
        ...item,
        fromDate: dateToFormat(new Date(item.fromDate), 'MM/dd/y'),
        toDate: formatToDate(item.fromDate, item.toDate),
        returnComponent: item.name,
      })) || [],
    columns,
    actionDeleteRow,
  };
};
